import { Components, Theme } from '@mui/material';

export const getMuiAlertTitle = (
  theme: Theme,
): Components['MuiAlertTitle'] => ({
  styleOverrides: {
    root: {
      fontSize: 14,
      fontWeight: 700,
      lineHeight: '135%',
      color: theme.palette.grey[900],
      textAlign: 'left',
      marginTop: 0,
      marginBottom: theme.spacing(2),
    },
  },
});
